import Vue from "vue";
import { FormWizard, TabContent } from "vue-form-wizard";

import "vue-form-wizard/dist/vue-form-wizard.min.css";

Vue.component("FormWizard", FormWizard);
Vue.component("TabContent", TabContent);
